import Swiper from "swiper";
import SwiperCore, { Navigation, Pagination } from "swiper/core";
import { register } from "@shopify/theme-sections";

register("about_slider", {
  onLoad() {
    SwiperCore.use([Navigation, Pagination]);
    const breakpoint = window.matchMedia("(min-width:768px)");

    let mySwiperAbout;

    const breakpointChecker = function () {
      if (breakpoint.matches === true) {
        if (mySwiperAbout !== undefined) mySwiperAbout.destroy(true, true);
        return;
      } else if (breakpoint.matches === false) {
        return enableSwiper();
      }
    };

    const enableSwiper = function () {
      mySwiperAbout = new Swiper(".swiper-container-about", {
        loop: false,
        resistance: true,
        resistanceRatio: 0,
        pagination: {
          el: ".swiper-pagination",
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    };
    breakpoint.addEventListener("change", breakpointChecker);
    breakpointChecker();
  },
});
